"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleErrorState = exports.getPhoneErr = exports.getEmailErr = exports.firstCharToLowerCase = exports.getWidgetTypeFromPathname = exports.getButtonBg = exports.toLowerCase = exports.payloadToString = exports.ellipseAddress = exports.parseConsentData = exports.postMessage = exports.generateRandomString = void 0;
const js_base64_1 = require("js-base64");
const store_1 = require("../store");
const constants_1 = require("../constants");
const logger_1 = require("frontend-utils/logger");
const validator_1 = require("./validator");
const axios_1 = __importDefault(require("axios"));
const widgetSlice_1 = require("../store/widgetSlice");
const NFT_TYPE_KEY = "transferNftRequest";
const COIN_TYPE_KEY = "transferCoinRequest";
const LAMBDA_TYPE_KEY = "invokeLambdaRequest";
const CONSENT_KEY_TYPE = {
    [constants_1.CONSENT_TYPE.NFT_TRANSFER]: NFT_TYPE_KEY,
    [constants_1.CONSENT_TYPE.COIN_TRANSFER]: COIN_TYPE_KEY,
    [constants_1.CONSENT_TYPE.LAMBDA_INVOKE]: LAMBDA_TYPE_KEY,
};
__exportStar(require("./validator"), exports);
__exportStar(require("./authUtils"), exports);
__exportStar(require("./eip712Utils"), exports);
const generateRandomString = () => {
    const chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const passwordLength = 31;
    let password = "";
    for (var i = 0; i <= passwordLength; i++) {
        const randomNumber = Math.floor(Math.random() * chars.length);
        password += chars.substring(randomNumber, randomNumber + 1);
    }
    return password;
};
exports.generateRandomString = generateRandomString;
const sendMessageToMobileSDK = (eventType, message) => {
    const client = store_1.useStore.getState().client;
    const clientType = (client === null || client === void 0 ? void 0 : client.type) || null;
    const appId = store_1.useStore.getState().appId;
    const mobilePackage = (client === null || client === void 0 ? void 0 : client.package) || null;
    const requestId = store_1.useStore.getState().requestId;
    const callbackPath = constants_1.CLIENT_TYPE_MAP[clientType];
    const response = {
        eventType: eventType,
        requestId: requestId,
        payload: message,
    };
    const responseB64 = js_base64_1.Base64.encode(JSON.stringify(response));
    const callback = `${mobilePackage}://${appId}.${constants_1.MOBILE_REDIRECT_HOST}/${callbackPath}/${mobilePackage}/callback?responseB64=${responseB64}`;
    window.location.href = callback;
};
/**
 * @param {string} eventType - event type to be sent to the iframe
 * @param {any} message - message, payload to be sent to the iframe
 * @param {boolean} removeFrame - if true, remove the iframe from the page
 */
// TODO: Rename to sendMessage to avoid confusing with window.postMessage()
const postMessage = (eventType, message, removeFrame = false) => {
    if (!eventType)
        return;
    const isMobile = store_1.useStore.getState().isMobileApp;
    // Check if the client is a mobile app
    if (isMobile) {
        if (eventType === constants_1.SUCCESS || eventType === constants_1.ERROR)
            sendMessageToMobileSDK(eventType, message);
        return;
    }
    // While running screenshot tests this helps to avoid postMessage invalid origin error
    const targetOrigin = constants_1.IS_SCREENSHOT_TEST
        ? "*"
        : store_1.useStore.getState().requesterDomain;
    try {
        window.parent.postMessage({ eventType: eventType, payload: message, removeFrame }, targetOrigin);
    }
    catch (err) {
        logger_1.logger.error(err);
    }
};
exports.postMessage = postMessage;
const getConsentType = (data) => {
    switch (true) {
        case data.hasOwnProperty(NFT_TYPE_KEY):
            return constants_1.CONSENT_TYPE.NFT_TRANSFER;
        case data.hasOwnProperty(COIN_TYPE_KEY):
            return constants_1.CONSENT_TYPE.COIN_TRANSFER;
        case data.hasOwnProperty(LAMBDA_TYPE_KEY):
            return constants_1.CONSENT_TYPE.LAMBDA_INVOKE;
        default:
            return null;
    }
};
const parseConsentData = (consentData) => {
    var _a, _b;
    const { developerName, tokenMetadata = {}, appLogoUrl = null, secondaryColor = constants_1.DEFAULT_LIGHT_THEME_BG_COLOR, contractData = {}, appId, skipFinalScreen = false, userWallet = {
        userMessageTemplate: "",
    }, } = consentData;
    const type = getConsentType(consentData);
    if (type === null)
        return {}; // Add type guard to handle null case
    const consentDetail = consentData[CONSENT_KEY_TYPE[type]];
    const obj = {
        toDetails: (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.to) || {},
        developerName,
        type,
        contractData,
        reason: "",
    };
    if (type === constants_1.CONSENT_TYPE.NFT_TRANSFER) {
        obj.fromUser = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.from) || null;
        obj.nftCollection = ((_a = consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.nft) === null || _a === void 0 ? void 0 : _a.collection) || null;
        obj.nftTokenId = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.token) || null;
        obj.tokenMetadata = tokenMetadata;
        obj.reason = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.reason) || "";
    }
    if (type === constants_1.CONSENT_TYPE.COIN_TRANSFER) {
        obj.fromUser = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.from) || null;
        obj.coin = ((_b = consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.coin) === null || _b === void 0 ? void 0 : _b.symbol) || null;
        obj.amount = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.amount) || null;
    }
    if (type === constants_1.CONSENT_TYPE.LAMBDA_INVOKE) {
        // In case of lambda invoke, from user is in the 'as' field.
        obj.fromUser = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.as) || null;
        obj.reason = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.reason) || "";
        obj.description = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.description) || {};
        obj.lambda = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.lambda) || "";
        obj.function = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.function) || {};
        obj.pay = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.pay) || 0;
        obj.invocations = (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.invocations) || [];
        obj.serializedTransactionMessage =
            (consentDetail === null || consentDetail === void 0 ? void 0 : consentDetail.serializedTransactionMessage) || "";
    }
    return {
        tokenData: obj,
        appInfo: {
            appLogoUrl,
            displayName: developerName,
            secondaryColor,
            appId,
            skipFinalScreen,
            userWallet,
        },
    };
};
exports.parseConsentData = parseConsentData;
const ellipseAddress = (address = "", width = 10) => {
    if (address == null) {
        return "";
    }
    return `${address.slice(0, width)}...${address.slice(-width)}`;
};
exports.ellipseAddress = ellipseAddress;
const payloadToString = (payload) => {
    if (typeof payload === "object")
        return JSON.stringify(payload, null, 2);
    return payload.toString();
};
exports.payloadToString = payloadToString;
const toLowerCase = (str) => typeof str === "string" ? str.toLowerCase() : str;
exports.toLowerCase = toLowerCase;
// If app theme is dark and button color is not set by user,
// then return button color to default dark theme color
// else return the color set by user.
// if not set default color is #333333
const getButtonBg = (appTheme, colorFromAppData) => {
    return appTheme === constants_1.DARK_THEME &&
        colorFromAppData === constants_1.DEFAULT_LIGHT_THEME_BG_COLOR
        ? constants_1.DEFAULT_DARK_THEME_BG_COLOR
        : colorFromAppData;
};
exports.getButtonBg = getButtonBg;
const getWidgetTypeFromPathname = (pathname = "") => {
    if (pathname === "/")
        return widgetSlice_1.WIDGET_TYPE.CONSENT;
    const splittedPathname = pathname.split("/");
    if (splittedPathname[1] === "login")
        return widgetSlice_1.WIDGET_TYPE.LOGIN;
    if (splittedPathname[1] === "sign")
        return widgetSlice_1.WIDGET_TYPE.APPROVAL;
    if (splittedPathname[1] === "prefetch")
        return widgetSlice_1.WIDGET_TYPE.PREFETCH;
    else
        throw new Error(constants_1.INVALID_REQUEST);
};
exports.getWidgetTypeFromPathname = getWidgetTypeFromPathname;
const firstCharToLowerCase = (str) => {
    if (typeof str !== "string")
        return str;
    return (0, exports.toLowerCase)(str.charAt(0)) + str.slice(1);
};
exports.firstCharToLowerCase = firstCharToLowerCase;
const getEmailErr = (email) => { var _a; return (_a = (0, validator_1.validator)("email", email)) === null || _a === void 0 ? void 0 : _a.email; };
exports.getEmailErr = getEmailErr;
const getPhoneErr = (phone) => { var _a; return (_a = (0, validator_1.validator)("phone", phone)) === null || _a === void 0 ? void 0 : _a.phone; };
exports.getPhoneErr = getPhoneErr;
const handleErrorState = (err, removeFrame = false) => {
    var _a;
    logger_1.logger.error(err);
    const setFrameState = store_1.useStore.getState().setFrameState;
    // Read error data
    let errData = null;
    const isAxiosError = axios_1.default.isAxiosError(err);
    if (isAxiosError) {
        errData = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data;
    }
    // Set default error message if no error data is present
    if (!errData) {
        errData = { status: constants_1.SOMETHING_WENT_WRONG };
    }
    if (!errData.status) {
        errData.status = constants_1.SOMETHING_WENT_WRONG;
    }
    // If the error is due to signature not yet valid, which can happen if
    // the device time is way out of sync with the server time, then we don't
    // want to remove the frame and instead show the error message to the user.
    if (errData.status === constants_1.API_SIGNATURE_NOT_YET_VALID) {
        removeFrame = false;
    }
    // Send error message to the parent
    (0, exports.postMessage)(constants_1.ERROR, errData, removeFrame);
    const { status = constants_1.SOMETHING_WENT_WRONG } = errData;
    setFrameState({ state: status, frameResponse: errData });
};
exports.handleErrorState = handleErrorState;
